import { TranslationMapLoaderEnum } from 'common/types/kraken-core/TranslationMap'

export interface LoaderMapping {
  icon: string
  name: string
  description: string
}

// Mapping for loader types defined in TranslationMapLoaderEnum
const LOADER_MAPPINGS: Record<TranslationMapLoaderEnum, LoaderMapping> = {
  [TranslationMapLoaderEnum.FILE_SYSTEM_LOADER]: {
    icon: 'file',
    name: 'File System',
    description: 'FileSystem',
  },
  [TranslationMapLoaderEnum.RUNTIME_DATABASE_LOADER]: {
    icon: 'cog',
    name: 'Runtime',
    description: 'Runtime Database Loader',
  },
  [TranslationMapLoaderEnum.LOGISTICS_FLOWS_LOADER]: {
    icon: 'truck-dryvan',
    name: 'Logistics',
    description: 'Logistics Flows',
  },
  [TranslationMapLoaderEnum.SHOPKEEPER_FLOWS_LOADER]: {
    icon: 'cog',
    name: 'Shopkeeper',
    description: 'Shopkeeper Flows',
  },
  [TranslationMapLoaderEnum.ONBOARDING_FLOWS_LOADER]: {
    icon: 'Onboarding',
    name: 'Onboarding',
    description: 'Onboarding Flows',
  },
  [TranslationMapLoaderEnum.LOGISTICS_ELD_FLOWS_LOADER]: {
    icon: 'truck-dryvan',
    name: 'Logistics ELD',
    description: 'Logistics ELD Flows',
  },
  [TranslationMapLoaderEnum.LOADBOARDS_FLOWS_LOADER]: {
    icon: 'TradingPartner',
    name: 'Loadboards',
    description: 'Loadboards Flows',
  },
  [TranslationMapLoaderEnum.DEMO_FLOWS_LOADER]: {
    icon: 'flag',
    name: 'Demo',
    description: 'Demo Flows',
  },
}

/**
 * Get the mapping for a loader value
 * @param loaderValue - The loader value to get mapping for
 * @returns LoaderMapping with icon, name, and description
 */
export function getLoaderMapping(loaderValue: string): LoaderMapping {
  // Check if the loader value is a valid enum value
  if (loaderValue in LOADER_MAPPINGS) {
    return LOADER_MAPPINGS[loaderValue as TranslationMapLoaderEnum]
  }

  // Default fallback for unknown loaders
  return {
    icon: 'cog',
    name: 'Unknown',
    description: loaderValue || 'Unknown Loader',
  }
}

/**
 * Get all available loader mappings
 * @returns Array of all loader mappings
 */
export function getAllLoaderMappings(): Array<{
  value: TranslationMapLoaderEnum
  mapping: LoaderMapping
}> {
  return Object.entries(LOADER_MAPPINGS).map(([value, mapping]) => ({
    value: value as TranslationMapLoaderEnum,
    mapping,
  }))
}
